import styled from "@emotion/styled";
import colors from "../../styles/colors";
import ReactSelect from "react-select";
export const ReactSelectStyled = styled(ReactSelect) `
  .react-select__placeholder,
  .react-select__single-value {
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.313rem;
    letter-spacing: 0em;
    text-align: left;
    color: ${colors["color-gray-100"]};
  }

  .react-select__single-value {
    color: ${(props) => getTextColorBasedOnState(props.showError, props.showWarning)};
  }

  .react-select__control {
    height: 2.25rem;
    min-height: 2.25rem;
    box-shadow: none;
    border-radius: 0.375rem;
    border: 0.078rem solid ${(props) => getBorderColorBasedOnState(props.showError, props.showWarning)};
    outline-width; 0;

    :hover {
      box-shadow: 0rem 0.125rem 0.25rem 0rem rgba(0, 0, 0, 0.1),
      0rem 0rem 0.063rem 0rem rgba(0, 0, 0, 0.28);
    }

    :focus-within {
      outline: none !important;
      border-color: none;
      box-shadow: none;
    }

    .react-select__value-container {
      margin-bottom: 0.125rem;

      .react-select__single-value{
        line-height: 0.875rem;
      }
    }

    .react-select__indicator{
      margin-top: -0.063rem;
    }
  }

  .react-select__control--is-focused {
    border: 0.078rem solid ${colors["color-blue-120"]};
    outline-width: 0;
    background-color: ${colors["color-blue-30"]};
    box-shadow: 0rem 0.125rem 0.25rem 0rem rgba(0, 112, 210, 0.15);
  }

  .react-select__menu-list {
    padding: 0px
  }

  .react-select__menu {
    margin: 0.125rem 0rem 0rem 0rem;
  }

  .react-select__option, .react-select__menu-notice {
    font-family: Inter;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.313rem;
    letter-spacing: 0em;
    text-align: left;
    display: flex;
    align-items: center;
  }

  .react-select__control--is-disabled {
    border: none;
  }

  .react-select__single-value--is-disabled {
      color: ${colors["color-gray-120"]};
  }

  .react-select__input {
    box-shadow: none;
  }

  &.react-select-custom-create, &.react-select-custom-create-disabled{
    .react-select__option:last-child {
      border-top: 0.063rem solid #eee;
      padding: 0.75rem;
      font-size: 0.875rem;
      font-weight: 600;
      line-height: 150%;
      position: sticky;
      bottom: 0px;
      background-color: white;
      border-bottom-left-radius: 0.375rem;
      border-bottom-right-radius: 0.375rem;
    }
    .react-select__option--is-focused:last-child {
      background-color: white;
      border-bottom-left-radius: 0.375rem;
      border-bottom-right-radius: 0.375rem;
    }
  }

  &.react-select-custom-create {
    .react-select__option:last-child {
      color: ${colors["color-blue-100"]};
      cursor: pointer;
    }
  }

  &.react-select-custom-create-disabled {
    .react-select__option:last-child {
      color: ${colors["color-gray-100"]};
      pointer-events: none;
    }
  }


`;
export const ReactSelectContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
`;
function getBorderColorBasedOnState(showError, showWarning) {
    if (showError)
        return colors["color-red-120"];
    if (showWarning)
        return colors["color-gold-100"];
    return colors["color-gray-100"];
}
function getTextColorBasedOnState(showError, showWarning) {
    if (showError)
        return colors["color-red-160"];
    else if (showWarning)
        return colors["color-gold-160"];
    else
        return colors["color-black-100"];
}
//# sourceMappingURL=DropdownField.styled.js.map